<div id="races" class="scrollTarget">
	<div class="section">
		<particles></particles>
		<div class="sectionDivider"></div>
		<div class="">
			<div class="raceSelection">
				<div class="raceName">
					<span i18n="chooseRaceElves@@chooseRace.race.elves" *ngIf="currentRace == 'elves'">Elves</span>
					<span i18n="chooseRaceDwarves@@chooseRace.race.dwarves" *ngIf="currentRace == 'dwarfs'">Dwarves</span>
				</div>
				<div class="characterSelection">
					<div class="arrow arrow-left" (click)="previousRace()"  angulartics2On="click" angularticsAction="previousRaceButton" angularticsCategory="interactive"></div>
					<div class="character" [class.elves]="currentRace == 'elves'" [class.dwarfs]="currentRace == 'dwarfs'"></div>
					<div class="arrow arrow-right" (click)="nextRace()"  angulartics2On="click" angularticsAction="nextRaceButton" angularticsCategory="interactive"></div>
				</div>
				<div class="chooseRace">
					<div class="spacer"></div>
					<div class="chooseRaceHeadline" i18n="chooseRaceElves@@chooseRace.chooseRace">Choose your Race</div>
					<div class="raceIcons">
						<div class="race elves" [class.active]="currentRace == 'elves'" (click)="selectRace('elves')"  angulartics2On="click" angularticsAction="selectElvesButton" angularticsCategory="interactive">
							<div class="icon"></div>
							<div class="name" i18n="chooseRaceElves@@chooseRace.race.elves">Elves</div>
						</div>
						<div class="race dwarfs" [class.active]="currentRace == 'dwarfs'" (click)="selectRace('dwarfs')"  angulartics2On="click" angularticsAction="selectDwarfsButton" angularticsCategory="interactive">
							<div class="icon"></div>
							<div class="name" i18n="chooseRaceElves@@chooseRace.race.dwarves">Dwarves</div>
						</div>
					</div>
					<div class="spacer"></div>
					<div class="raceDescription">
						<div class="elves" *ngIf="currentRace == 'elves'">
							<div class="attribute">
								<div class="icon culture"></div>
								<div class="text">
									<div class="headline" i18n="chooseRaceElves@@chooseRace.attribute.elves.culture.headline">Culture</div>
									<div class="description" i18n="chooseRaceElves@@chooseRace.attribute.elves.culture.description">The beauty of Arkheim’s Elves is only surpassed by their ruthlessness. Enter their ranks and experience a life free of any law but one – the law of the jungle.</div>
								</div>
							</div>
							<div class="attribute">
								<div class="icon combat"></div>
								<div class="text">
									<div class="headline" i18n="chooseRaceElvesHeadline@@chooseRace.attribute.elves.combat.headline">Combat</div>
									<div class="description" i18n="chooseRaceElvesDescription@@chooseRace.attribute.elves.combat.description">Menacing warriors and feral beasts tear up the frontlines, while plant-based artillery crushes any last resistance.</div>
								</div>
							</div>
						</div>
						<div class="elves" *ngIf="currentRace == 'dwarfs'">
							<div class="attribute">
								<div class="icon culture"></div>
								<div class="text">
									<div class="headline" i18n="chooseRaceDwarvesHeadline@@chooseRace.attribute.dwarves.culture.headline">Culture</div>
									<div class="description"  i18n="chooseRaceDwarvesDescription@@chooseRace.attribute.dwarves.culture.description">Dwarves are united in their vision to make everything into a perfect shape, which in their eyes, is a well-polished cube. They will continuously hammer away on rocks, mountains, and foes until their grand vision is complete.</div>
								</div>
							</div>
							<div class="attribute">
								<div class="icon combat"></div>
								<div class="text">
									<div class="headline" i18n="chooseRaceElves@@chooseRace.attribute.dwarves.combat.headline">Combat</div>
									<div class="description" i18n="chooseRaceElves@@chooseRace.attribute.dwarves.combat.description">Forgers of the sturdiest armor and heaviest weapons, Dwarven armies consist of unflinching soldiers and devastating artillery.</div>
								</div>
							</div>
						</div>
					</div>
					<div class="spacer"></div>
					<div class="shortDescription">
						<span *ngIf="currentRace == 'elves'" i18n="chooseRaceElves@@chooseRace.attribute.elves.shortDescription">Fast and Dangerous</span>
						<span *ngIf="currentRace == 'dwarfs'" i18n="chooseRaceElves@@chooseRace.attribute.dwarves.shortDescription">Strong and Enduring</span>
					</div>
					<div class="summary">
						<div class="registerButton">
							<preregister-button *ngIf="env.settings.preRegOnly" angulartics2On="click" angularticsAction="preReg_openPopup_selectRace" angularticsCategory="preregistration"></preregister-button>
							<register-button *ngIf="!env.settings.preRegOnly" angulartics2On="click" angularticsAction="reg_openPopup_selectRace" angularticsCategory="registration"></register-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>